var Vendd = (function (Vendd) {
    'use strict';

    Vendd.User = (function (User) {
        User.AuthProviders = (function (AuthProviders) {

            var fb = {

                getStatus: function (onSuccess, onError) {
                    FB.getLoginStatus(onSuccess, onError);
                },

                getUser: function (onSuccess, onError) {
                    FB.api('/me/permissions', function (response) {
                        if (response && response.data) {
                            var emailPermission = _.find(response.data, function (x) { return x.permission === 'email'; });
                            if (emailPermission && emailPermission.status === 'granted') {
                                FB.api('/me?fields=id,name,email,first_name,last_name', onError, onSuccess);
                            }
                            else {
                                onError(new Error('email permission doesn\'t exist'));
                            }
                        }
                        else {
                            onError(new Error('response is undefined'));
                        }
                    });
                },

                connect: function (loginId, email, onSuccess, onError) {
                    Vendd.Service.call({
                        url: 'AuthService.svc/ConnectAuthenticationProvider',
                        data: {
                            provider: 'facebook',
                            loginId: loginId,
                            email: email
                        },
                        onSuccess: onSuccess,
                        onFailure: onError
                    });
                },

                login: function () {
                    window.open(AuthProviders.facebook.Configuration.AuthUrl, 'fbLogin', 'status=1,toolbar=0,location=0,menubar=0,directories=0,resizable=0,scrollbars=0,height=265,width=600');
                },

                logout: function (cb) {
                    FB.logout(cb);
                }
            };

            var deleteFbCookie = function () {
                var theCookies = document.cookie.split(';');
                for (var i = 0 ; i < theCookies.length; i++) {

                    var c = theCookies[i];
                    while (c.charAt(0) == ' ') c = c.substring(1);

                    var cparts = c.split('=');
                    var name;
                    if (cparts.length == 2)
                        name = cparts[0];

                    if (name && (name.indexOf("fblo_") == 0 || name.indexOf("fbsr_") == 0)) {
                        document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC";
                    }
                }
            }

            var throwEx = function (ex) {
                if (typeof (ex) === typeof (Error))
                    throw ex;
                else
                    console.log(ex);
            }

            AuthProviders.facebook = {

                isAvailable: true,
                initiating: false,
                initiated: false,

                Configuration: {
                    AppId: '',
                    PageId: '',
                    AuthUrl: ''
                },

                init: function () {
                    var me = this;

                    if (!me.initiating && !me.initiated) {
                        me.initiating = true;

                        Vendd.Service.call({
                            url: 'Auth/FacebookLoginService.svc/GetConfiguration',
                            data: {},
                            onSuccess: function (res) {
                                 
                                me.Configuration.AppId = res.appId;
                                me.Configuration.PageId = res.pageId;
                                me.Configuration.AuthUrl = res.authUrl;

                                if (typeof (FB) === "object") {
                                    me.initiated = true;
                                } else {
                                    window.fbAsyncInit = function () {
                                        FB.init({
                                            appId: me.Configuration.AppId,
                                            pageId: me.Configuration.PageId,
                                            cookie: false,
                                            xfbml: true,
                                            version: 'v3.2'
                                        });

                                        me.initiated = true;
                                    };

                                    (function (d, s, id) {
                                        var fjs = d.getElementsByTagName(s)[0];
                                        if (d.getElementById(id))
                                            return;

                                        var js = d.createElement(s);
                                        js.id = id;
                                        js.src = '//connect.facebook.net/en_US/all.js';
                                        js.onload = function (e) {
                                            me.isAvailable = true;
                                        };
                                        js.onerror = function (e) {
                                            me.isAvailable = false;
                                            console.warn('Facebook authentication provider is not available via this network! All FB calls will be ignored..');
                                        };

                                        fjs.parentNode.insertBefore(js, fjs);
                                    }(document, 'script', 'facebook-jssdk'));
                                }
                            },
                            onFailure: function (ex) {
                                throw ex;
                            }
                        });
                    }
                },

                statusChanged: function (statusResponse) {
                    var me = this;

                    if (!me.isAvailable) return;

                    if (statusResponse.status === 'connected') {
                        var facebookid = statusResponse.authResponse.userID;

                        fb.getUser(function (userResponse) {
                            fb.connect(facebookid, userResponse.email, function (connectedResponse) {
                                if (connectedResponse !== 'Connected') {
                                    if (connectedResponse === 'Authenticated') {
                                        document.location = document.location;
                                    }
                                    else if (connectedResponse === 'CreatedAndAuthenticated') {
                                        document.location = document.location;
                                    }
                                    else if (connectedResponse === 'Disconnected') {
                                        fb.login();
                                    }
                                }
                            }, function (connectedEx) {
                                throwEx(connectedEx);
                            });

                        }, function (userEx) {
                            throwEx(userEx);
                        });
                    }
                },

                checkLoginState: function () {
                    var me = this;

                    if (!me.isAvailable) return;

                    fb.getStatus(function (response) {
                        me.statusChanged(response);
                    }, function (ex) {
                        throw ex;
                    });
                },

                login: function () {
                    var me = this;

                    if (!me.isAvailable) return;

                    fb.login();
                },

                logout: function (cb) {
                    var me = this;

                    if (!me.isAvailable) {
                        cb();
                        return;
                    }

                    fb.getStatus(function(statusResponse) {
                        if (statusResponse.status === 'connected') {
                            fb.logout(function() {

                                //Facebook bugfix: delete cookie
                                deleteFbCookie();

                                cb();
                            });
                        } else {
                            cb();
                        }
                    }, function(ex) {
                        cb();
                    });
                }

            };

            return AuthProviders;

        })(User.AuthProviders || {});

        return User;

    })(Vendd.User || {});

    return Vendd;

})(Vendd || {});